import { Download } from "lucide-react";
import { toast } from "sonner";
import { useInstallPrompt } from "@/lib/pwa";

export const InstallButton = ({ className = "", testId = "install-app-btn" }) => {
  const { canInstall, install, isStandalone } = useInstallPrompt();
  const onClick = async () => {
    if (isStandalone) return toast.success("AETRYX is already installed on this device.");
    if (canInstall) {
      const ok = await install();
      if (ok) toast.success("AETRYX installed. Enjoy the show.");
      return;
    }
    toast("Install AETRYX", { description: "Open your browser menu and choose “Install app” or “Add to Home Screen”." });
  };
  return (
    <button data-testid={testId} onClick={onClick} className={`btn-ghost-gold px-5 py-2 ${className}`}>
      <Download className="h-4 w-4 text-[#D4AF37]" /> {isStandalone ? "App Installed" : "Install App"}
    </button>
  );
};
